import React from 'react';
import { resizeLegalIframe } from '../../utils/legalIframeResize';

export default function Agreement(props) {
  return (
    <>
      <section className="location_box">
        <ul className="location_001">
          <li>Home</li>
          <li>서비스이용약관</li>
        </ul>
      </section>

      <main>
        <section className="contants_box contants_box_02">
          <h2 className="tit_01">서비스이용약관</h2>

          <article className="contants_box_02 agreement_box">
            <iframe
              src="/agreement_wrap.html"
              title="agreement_wrap"
              onLoad={resizeLegalIframe}
            ></iframe>
          </article>
        </section>
      </main>
    </>
  );
}
